



















import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import EventBus from '../services/eventbus.service';
import {Getter, Mutation} from 'vuex-class';

@Component({
  components: {
  },
})
export default class FilterBar extends Vue {
  private filters: string[] = [];
  @Mutation private removeAllWidgetFilters: any;
  @Mutation private removeWidgetFilter: any;
  @Prop() private clearFilters!: any;

  private mounted() {
    EventBus.$on('filterByProject', this.filterBy);
  }

  private beforeDestroy() {
    EventBus.$off('filterByProject', this.filterBy);
  }

  private async clearFilter(filter?: string) {
    if (filter) {
      this.filters = this.filters.filter((f: string) => f !== filter);
      this.removeWidgetFilter();
    } else {
      this.filters = [];
      this.removeAllWidgetFilters();
    }
    EventBus.$emit('clearFilter');
    this.clearFilters();
  }

  private filterBy(filter: string | null) {
    if (!filter) {
      this.clearFilter();
      return;
    }
    if (!this.filters.includes(filter)) {
      this.filters.push(filter);
    }
  }
}
